import { render, staticRenderFns } from "./TutorialWrongPagePopup.vue?vue&type=template&id=626460a3&scoped=true&"
import script from "./TutorialWrongPagePopup.vue?vue&type=script&lang=js&"
export * from "./TutorialWrongPagePopup.vue?vue&type=script&lang=js&"
import style0 from "./TutorialWrongPagePopup.vue?vue&type=style&index=0&id=626460a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626460a3",
  null
  
)

export default component.exports